module.exports = __webpack_public_path__ + "static/media/icon_placeholder.ba0b1f17.svg";